import * as Yup from "yup";
import "yup-phone";

export const ReportTemplateSchemaForAugmentoTemplates = (t) => Yup.object({
  title: Yup.string().required(t("string-literals.report-template-title-empty")).max(100, t("string-literals.report-template-title-max-length")).matches(/^[a-zA-Z0-9\-,_\"'&:()\s]*$/i, t("string-literals.report-template-title-invalid")),
  report:Yup.string().required(t("string-literals.report-template-report-empty"))
});
